import { render, staticRenderFns } from "./QuestionsHeader.vue?vue&type=template&id=60a555e0&scoped=true&"
import script from "./QuestionsHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsHeader.vue?vue&type=style&index=0&id=60a555e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a555e0",
  null
  
)

export default component.exports